import React, { useState, useEffect } from 'react';
import {
    Typography,
    Box,
} from '@mui/material';
import { axios_tenant } from "../../../axios";
import {toast} from "react-toastify";
import ReferenceTable from './ReferenceTable.js';
import UploadMetadata from './uploadMetadata.js';


const Component = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadRequests = async () => {
    setLoading(true);
    axios_tenant.get('/reference-downloader/requests').then(response => {
      setRequests(response.data);
    }).catch(error => {
      toast.error("Failed to load requests");
      console.error("Failed to load reference downloader requests", error);
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    loadRequests();
  }, []);

  return (
    <Box sx={{ px: { xs: 1, sm: 2, md: 3, lg: 5 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h1">Reference Retrieval Queue</Typography>
        <UploadMetadata loadRequests={loadRequests} loadingRequests={loading}/>
      </Box>
      <ReferenceTable requests={requests} loadRequests={loadRequests} loading={loading} setLoading={setLoading} />
    </Box>
  );
};

export default Component;
